import { DocumentWithContentAcceptedTypes } from "src/contexts/_shared/domain/valueObjects/DocumentWithContentAcceptedContentType";

export const WRONG_FILE = "documentation_area.payslip_ai.wrong_file";
export const WRONG_FILE_MESSAGE = "documentation_area.payslip_ai.wrong_file.explanation";
export const FILES_TOO_LARGE_TITLE = "documentation_area.payslip_ai.files_too_large";
export const FILES_TOO_LARGE_DESCRIPTION =
  "documentation_area.payslip_ai.files_too_large.description";
export const ERROR_GENERIC = "documentation_area.error.generic";
export const ERROR_GENERIC_DESCRIPTION = "documentation_area.error.generic_description";
export const ERROR_FILE_LIMIT = "documentation_area.error.file_limit";
export const ERROR_FILE_LIMIT_DESCRIPTION = "documentation_area.error.file_limit_description";

export const MAX_TOTAL_SIZE = 15 * 1024 * 1024 - 1000; // With extra safety margin

// Accepted upload file types for the uploader component
export const ACCEPTED_UPLOAD_FILE_TYPES = Object.values(DocumentWithContentAcceptedTypes).join(",");
